import './index.css';

function App() {
  return (
    <><iframe src="https://pct4k7-3000.csb.app/" title="Site"/></>
  );
}

export default App;
